/*! ===========================================================================
    STIMA DI CONSEGNA — MOTORE UNICO

    Sostituisce le tre copie della logica che stavano in:
      - snippets/main-product-info.liquid  (blocco prodotto, script inline)
      - snippets/mobile-product-atc-bar.liquid
      - assets/custom.js                   (righe carrello)

    Consumatori (si agganciano da soli via data-attribute):
      .delivery-estimate  blocco "Stima di consegna" in pagina prodotto
      #mobile-product-atc barra "Aggiungi al carrello" mobile
      .de-cart            righe del carrello (pagina + drawer, anche via AJAX)

    Contratto di ogni elemento:
      data-handover        giorni lavorativi di affido al corriere (0 ammesso)
      data-tmin/data-tmax  giorni lavorativi di TRANSITO (non il totale)
      data-vendor          fornitore, per agganciare le chiusure
      data-cutoff          ora limite ordine 0-23 ("" = nessuna)
      data-skip-weekends   "1" | "0"
      data-holidays        festività extra AAAA-MM-GG separate da virgola
      data-de-format       "full" (default) | "compact"

    Configurazione globale in window.DE_CONFIG, emessa da
    snippets/delivery-estimate-config.liquid.

    DUE GAMBE, NON UNA. La data di consegna si ottiene in due passaggi:
      1. affido  = N giorni lavorativi da oggi, saltando weekend, festività
                   E le chiusure del fornitore;
      2. transito = M giorni lavorativi dall'affido, saltando weekend e
                   festività ma NON le chiusure (il corriere lavora comunque).
    Senza chiusure configurate le due gambe danno esattamente lo stesso
    risultato del vecchio calcolo in un colpo solo: nessuna regressione.
=========================================================================== */
(function () {
  'use strict';
  if (window.DeliveryEstimate) return;

  var CFG = window.DE_CONFIG || {};
  var TZ = CFG.timezone || 'Europe/Rome';

  /* ── Date ────────────────────────────────────────────────────────────────
     Ogni data di calendario è materializzata a mezzogiorno locale: sommare
     giorni a mezzanotte fa sbagliare di un giorno ai cambi di ora legale. */
  function dateFromYmd(s) {
    var p = String(s).split('-');
    return new Date(+p[0], +p[1] - 1, +p[2], 12, 0, 0, 0);
  }
  function ymd(d) {
    return d.getFullYear() + '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
      ('0' + d.getDate()).slice(-2);
  }
  function addDays(d, n) {
    var x = new Date(d.getTime());
    x.setDate(x.getDate() + n);
    return x;
  }

  /* Adesso nel fuso del NEGOZIO, non del visitatore: l'ora limite è una
     regola di magazzino e non deve cambiare in base a dove si trova chi
     guarda la pagina. */
  function shopNow() {
    var d = new Date();
    try {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', hour12: false
      }).formatToParts(d).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
      return {
        date: dateFromYmd(p.year + '-' + p.month + '-' + p.day),
        hour: parseInt(p.hour, 10) % 24            /* alcuni motori danno "24" a mezzanotte */
      };
    } catch (e) {
      return { date: dateFromYmd(ymd(d)), hour: d.getHours() };
    }
  }

  function isBusiness(d, skipWe, holidays) {
    var w = d.getDay();
    if (skipWe && (w === 0 || w === 6)) return false;
    return holidays.indexOf(ymd(d)) === -1;
  }

  /* n giorni lavorativi DOPO start (start escluso). Semantica identica al
     modulo precedente: cambiarla sposterebbe tutte le date del sito. */
  function addBusiness(start, n, skipWe, holidays) {
    var d = new Date(start.getTime()), added = 0, guard = 0;
    while (added < n && guard++ < 800) {
      d = addDays(d, 1);
      if (isBusiness(d, skipWe, holidays)) added++;
    }
    return d;
  }

  /* ── Chiusure fornitore ──────────────────────────────────────────────── */
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function closuresFor(vendor) {
    var all = CFG.closures || [], key = norm(vendor), out = [];
    if (!key) return out;
    for (var i = 0; i < all.length; i++) {
      if (norm(all[i].vendor) === key) out.push(all[i]);
    }
    out.sort(function (a, b) { return a.start < b.start ? -1 : a.start > b.start ? 1 : 0; });
    return out;
  }

  /* Regola, applicata a ogni chiusura del fornitore in ordine di data.
     Con "ultima chiamata" valorizzata (es. IDROM: ultimo affido 07/08 ore 11)
     si distinguono due casi opposti:
       - ordine ENTRO la scadenza → il fornitore lo evade prima di chiudere,
         l'affido viene riportato all'ultimo giorno utile;
       - ordine OLTRE la scadenza → si slitta al primo giorno lavorativo dopo
         la riapertura (più eventuali giorni di smaltimento arretrati).
     Senza "ultima chiamata" la scadenza coincide con l'inizio della chiusura
     e resta il solo comportamento di slittamento. */
  function applyClosures(ship, now, closures, skipWe, holidays, dailyCutoff) {
    var closure = null, mode = null;
    var nowYmd = ymd(now.date);

    for (var i = 0; i < closures.length; i++) {
      var c = closures[i];
      var sYmd = ymd(ship);
      var hasLastCall = !!c.lastDate;
      var lastHour = c.lastHour == null ? (dailyCutoff == null ? 24 : dailyCutoff) : c.lastHour;

      /* La finestra in cui NON si spedisce parte dal giorno dopo l'ultimo
         affido, non dall'inizio della chiusura: molti fornitori smettono di
         spedire qualche giorno prima di chiudere davvero i battenti (es.
         ultimo affido il 4, ferie dall'8: il 5, 6 e 7 non parte nulla). */
      var inside = hasLastCall
        ? (sYmd > c.lastDate && sYmd <= c.end)
        : (sYmd >= c.start && sYmd <= c.end);
      var passed = hasLastCall
        ? (nowYmd > c.lastDate || (nowYmd === c.lastDate && now.hour >= lastHour))
        : (nowYmd >= c.start);

      if (!passed && hasLastCall && inside) {
        ship = dateFromYmd(c.lastDate);
        closure = c; mode = 'lastcall';
        continue;
      }
      if (passed || inside) {
        var resume = addBusiness(dateFromYmd(c.end), 1 + (c.extra || 0), skipWe, holidays);
        if (ship < resume) { ship = resume; closure = c; mode = 'delayed'; }
      }
    }
    return { ship: ship, closure: closure, mode: mode };
  }

  /* ── API ─────────────────────────────────────────────────────────────── */
  function compute(o) {
    var skipWe = o.skipWeekends !== false;
    var holidays = (CFG.holidays || []).concat(o.holidays || []);
    var cutoff = (o.cutoff == null || isNaN(o.cutoff)) ? null : o.cutoff;

    var now = shopNow();
    var base = now.date;
    if (cutoff !== null && now.hour >= cutoff) base = addDays(base, 1);

    var ship = addBusiness(base, o.handover || 0, skipWe, holidays);
    var r = applyClosures(ship, now, closuresFor(o.vendor), skipWe, holidays, cutoff);

    return {
      ship: r.ship,
      min: addBusiness(r.ship, o.tmin, skipWe, holidays),
      max: addBusiness(r.ship, o.tmax, skipWe, holidays),
      closure: r.closure,
      mode: r.mode
    };
  }

  /* ── Formattazione ───────────────────────────────────────────────────── */
  var fFull = new Intl.DateTimeFormat('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  var fDay = new Intl.DateTimeFormat('it-IT', { day: 'numeric' });
  var fDayMonth = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'short' });
  var fLong = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long' });
  var fWeekdayLong = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function compact(minDate, maxDate, single) {
    if (single) return fDayMonth.format(maxDate);
    var same = minDate.getMonth() === maxDate.getMonth() &&
      minDate.getFullYear() === maxDate.getFullYear();
    return same ? fDay.format(minDate) + '–' + fDayMonth.format(maxDate)
      : fDayMonth.format(minDate) + '–' + fDayMonth.format(maxDate);
  }

  /* ── Aggancio automatico ─────────────────────────────────────────────── */
  function intAttr(el, name) {
    var v = el.getAttribute(name);
    if (v === null || v === '') return NaN;
    return parseInt(v, 10);
  }

  function fill(el) {
    if (el.getAttribute('data-de-filled') === '1') return;

    var handover = intAttr(el, 'data-handover');
    var tmin = intAttr(el, 'data-tmin');
    if (isNaN(handover)) handover = 0;
    if (isNaN(tmin)) return;
    var tmax = intAttr(el, 'data-tmax');
    if (isNaN(tmax)) tmax = tmin;

    /* La barra mobile eredita le regole di calendario dal blocco in pagina,
       se c'è: così segue l'ora limite impostata da editor invece del proprio
       valore di ripiego. */
    var rules = el;
    var inherit = el.getAttribute('data-de-inherit');
    if (inherit) rules = document.querySelector(inherit) || el;

    var cutoff = intAttr(rules, 'data-cutoff');

    var r = compute({
      handover: handover,
      tmin: tmin,
      tmax: tmax,
      vendor: el.getAttribute('data-vendor'),
      cutoff: isNaN(cutoff) ? null : cutoff,
      skipWeekends: rules.getAttribute('data-skip-weekends') !== '0',
      holidays: (rules.getAttribute('data-holidays') || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    });

    var single = tmin === tmax;

    if (el.getAttribute('data-de-format') === 'compact') {
      var range = el.querySelector('[data-mpa-range]');
      if (range) range.textContent = compact(r.min, r.max, single);
    } else {
      var minEl = el.querySelector('[data-delivery-min]');
      var maxEl = el.querySelector('[data-delivery-max]');
      if (minEl) minEl.textContent = cap(fFull.format(r.min));
      if (maxEl) maxEl.textContent = cap(fFull.format(r.max));
    }

    /* Chiusura in corso: la riga "affidato al corriere entro X giorni" sarebbe
       falsa, il CSS la nasconde. Solo quando la stima è stata davvero
       posticipata — quindi anche quando la scadenza dell'ultimo affido è già
       passata e il fornitore non ha ancora chiuso i battenti. In tutti gli
       altri casi la riga resta al suo posto. */
    if (el.classList) {
      if (r.mode === 'delayed') el.classList.add('is-supplier-closed');
      else el.classList.remove('is-supplier-closed');
    }

    /* Nota di chiusura: compare solo quando la stima è stata effettivamente
       posticipata, e solo se il markup ha predisposto il contenitore. */
    var note = el.querySelector('[data-delivery-note]');
    if (note) {
      if (r.mode === 'delayed' && r.closure) {
        var tpl = note.getAttribute('data-note-template') || '';
        note.innerHTML = tpl
          .replace('{riapertura}', cap(fWeekdayLong.format(r.ship)))
          .replace('{fine_chiusura}', fLong.format(dateFromYmd(r.closure.end)))
          .replace('{nota}', r.closure.note || '');
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    el.setAttribute('data-de-filled', '1');
  }

  var SEL = '.delivery-estimate[data-handover], .de-cart[data-handover], #mobile-product-atc[data-handover]';

  function fillAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      try { fill(nodes[i]); } catch (e) { /* un elemento rotto non deve fermare gli altri */ }
    }
  }

  window.DeliveryEstimate = { compute: compute, refresh: fillAll, fill: fill };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }

  /* Il drawer carrello viene rigenerato via Section Rendering API: le righe
     nuove arrivano dopo il primo passaggio. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var raf = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };
    raf(function () { scheduled = false; fillAll(); });
  }
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);
})();
